import axios from 'axios'
import { ref, onMounted } from 'vue'
import { useAuthStore } from '@/stores/useAuthStore.js'

export default function useAuthorization() {
  const authStore = useAuthStore()
  const usersApi = axios.create({
    baseURL: import.meta.env.VITE_USERS_API_URL + 'request',
    headers: authStore.getUserToken ? { Authorization: `Bearer ${authStore.getUserToken}` } : {},
  })

  const permissions = ref([])

  onMounted(async () => {
    await fetchPermissions() //To remove
    loadPermissions()
  })

  async function fetchPermissions() {
    const response = await usersApi.post('/', {
      request: 'auth',
      type: 'authorization',
    })

    permissions.value = response?.data?.data ?? {}

    localStorage.setItem('auth_permissions', JSON.stringify(permissions.value))
  }

  function loadPermissions() {
    permissions.value =
      localStorage.getItem('auth_permissions') ?
      JSON.parse(localStorage.getItem('auth_permissions')) : []
  }

  //Actions
  function can(permissionCode) {
    return permissions.value.includes(permissionCode)
  }

  function canAll(permissionCodes) {
    return permissionCodes.every(code => permissions.value.includes(code))
  }

  function canAny(permissionCodes) {
    return permissionCodes.some(code => permissions.value.includes(code))
  }

  function hasRole(roleCodeOrName) {
    return roles.value.includes(roleCodeOrName)||
      assignedRoles.value.some(role => role.name === roleCodeOrName)
  }

  function hasAnyRole(roleCodesOrNames) {
    return roleCodesOrNames.some(hasRole)
  }

  //Sync
  async function syncPermission(permissionCodes) {
    await usersApi.post('/', {
      request: 'user_permission',
      type: 'syncPermissionToUser',
      values: {
        permissions: permissionCodes,
      },
    })
  }

  async function syncRole(roleCodes) {
    const normalizedRoleCodes = [...new Set((roleCodes ?? []).map(role => {
      if (typeof role === 'string') return role.trim()
      return String(role?.code ?? '').trim()
    }).filter(Boolean))]

    await usersApi.post('/', {
      request: 'user_role',
      type: 'syncRoleToUser',
      values: {
        roles: normalizedRoleCodes,
      },
    })

    return refreshAuthorization()
  }

  return {
    permissions,
    syncPermission,
    syncRole,
    can,
    canAll,
    canAny,
    hasRole,
    hasAnyRole,
  }
}
